// Plan derivation from /auth/me ownedEntitlements (phase 10 §C).
//
// Entitlements are PER-USER: they live on the caller's UsersTable row
// (keyed by email, with the lifetime env merge applied plane-side in
// auth/me). They never ride the tenant threading — on the plane, the
// "ownerEmail" table ATTRIBUTE holds a tenantId (personal tenant = the
// user's email; team tenant = teamId uuid), but plan gates always read the
// CALLER's entitlements regardless of which tenant the dashboard is
// viewing. `lifetime` (env-granted) implies pro + teams; auth/me already
// merges all three into ownedEntitlements, so the includes() checks below
// are belt-and-suspenders for older planes.

export function hasPro(ents: readonly string[]): boolean {
  return ents.includes("pro") || ents.includes("lifetime");
}

export function hasTeams(ents: readonly string[]): boolean {
  return ents.includes("teams") || ents.includes("lifetime");
}

export function hasLifetime(ents: readonly string[]): boolean {
  return ents.includes("lifetime");
}

export type PlanLabel = "lifetime" | "pro" | "teams" | "free";

/** One word for the dashboard plan chip — lifetime > pro > teams > free
 *  (lifetime subsumes the other two; pro is the personal headline when
 *  someone owns both pro and teams). */
export function planLabel(ents: readonly string[] | undefined): PlanLabel {
  if (!ents) return "free";
  if (ents.includes("lifetime")) return "lifetime";
  if (ents.includes("pro")) return "pro";
  if (ents.includes("teams")) return "teams";
  return "free";
}
